// https://github.com/cachecontrol/json-rules-engine/blob/HEAD/docs/rules.md#operators

export enum ARRAY_OPERATORS {
  in = 'in', // fact must be included in value (an array)
  notIn = 'notIn', // fact must not be included in value (an array)
  contains = 'contains', // fact (an array) must include value
  doesNotContain = 'doesNotContain', // fact (an array) must not include value
}
